export function mapEnumToLabelObject(enumObj: any, statusMap: any): { key: string, value: string }[] {
  return Object.keys(enumObj).map(key => ({
      key,
      value: statusMap[key] ? statusMap[key].label : enumObj[key],
  }));
}
